const backendOrigin = (() => {
  try {
    return new URL(process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1').origin;
  } catch {
    return 'http://localhost:8000';
  }
})();

/** Prefix relative src/href attributes with the Django backend origin. */
export const resolveMediaUrls = (html: string): string =>
  html.replace(/(src|href)="(\/[^"]+)"/g, `$1="${backendOrigin}$2"`);
